import React, { FC } from 'react';
import { DrmPage, FieldType, FieldTabPlacement } from 'v2/models';
import { FieldTypeProps } from 'v2/common/DRM/CustomTab/Field/props';
import TextField from './FieldTypes/TextField/TextField';
import NumberField from './FieldTypes/NumberField/NumberField';
import BooleanField from './FieldTypes/BooleanField/BooleanField';
import CurrencyField from './FieldTypes/CurrencyField/CurrencyField';
import DateField from './FieldTypes/DateField/DateField';
import LongTextField from './FieldTypes/LongTextField/LongTextField';
import RichTextField from './FieldTypes/RichTextField/RichTextField';
import DropdownField from 'v2/common/DRM/CustomTab/Field/FieldTypes/DropdownField';
import MultiselectField from 'v2/common/DRM/CustomTab/Field/FieldTypes/MultiselectField/MultiselectField';

const renderers: Record<FieldType, FC<FieldTypeProps>> = {
  text: TextField,
  number: NumberField,
  boolean: BooleanField,
  currency: CurrencyField,
  rich_text: RichTextField,
  long_text: LongTextField,
  date: DateField,
  list_of_strings: DropdownField,
  multiple_choice: MultiselectField,
};

interface FieldProps {
  field: FieldTabPlacement;
  entity: Record<string, unknown>;
  onUpdate: (entity: Record<string, unknown>) => void;
  drmPage: DrmPage;
}

const Field = ({ field, entity, onUpdate, drmPage }: FieldProps) => {
  const fieldLabel = field.label || field.field_name;
  const fieldName = field.field_name;
  const value = entity?.[fieldName];

  if (
    typeof value !== 'string' &&
    typeof value !== 'number' &&
    typeof value !== 'boolean' &&
    value !== null
  ) {
    return null;
  }

  return (
    <>
      {renderers[field.field_type]({
        fieldName,
        fieldLabel,
        entity,
        value,
        onUpdate,
        drmPage,
      })}
    </>
  );
};

export default Field;
